import { Instagram, Heart, MessageCircle, ArrowUpRight } from "lucide-react";
import { Reveal, Stagger, StaggerItem } from "@/components/site/Reveal";
import { Eyebrow } from "@/components/site/ui";
import { INSTAGRAM_POSTS, CONTACT } from "@/data/site";

export default function InstagramFeed() {
  return (
    <section className="relative py-20 sm:py-28 bg-ink-900/50 border-y border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-12">
          <Reveal>
            <Eyebrow>Sosyal Akış</Eyebrow>
            <h2 className="mt-4 font-display text-3xl sm:text-5xl font-extrabold break-words">Son paylaşımlarımız</h2>
            <a href={CONTACT.instagramUrl} target="_blank" rel="noreferrer" className="mt-3 inline-flex items-center gap-2 text-neon-pink hover:text-white transition-colors font-semibold">
              <Instagram className="w-5 h-5" /> {CONTACT.instagram}
            </a>
          </Reveal>
          <Reveal delay={0.1}>
            <a
              href={CONTACT.instagramUrl} target="_blank" rel="noreferrer"
              data-testid="instagram-follow-cta"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-gradient-to-r from-neon-purple to-neon-magenta text-white font-semibold hover:scale-[1.03] transition-transform"
            >
              <Instagram className="w-4 h-4" /> Takip Et
            </a>
          </Reveal>
        </div>

        <Stagger className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-4">
          {INSTAGRAM_POSTS.map((p, i) => (
            <StaggerItem key={i}>
              <a
                href={CONTACT.instagramUrl} target="_blank" rel="noreferrer"
                data-testid={`instagram-post-${i}`}
                className="group relative block aspect-square rounded-2xl overflow-hidden border border-white/10"
              >
                <img src={p.img} alt="Instagram gönderisi" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-ink-900/90 via-ink-900/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex flex-col items-center justify-center gap-2">
                  <div className="flex items-center gap-4 text-white font-semibold text-sm">
                    <span className="flex items-center gap-1"><Heart className="w-4 h-4 fill-white" /> {p.likes}</span>
                    <span className="flex items-center gap-1"><MessageCircle className="w-4 h-4 fill-white" /> {p.comments}</span>
                  </div>
                  <Instagram className="w-6 h-6 text-white" />
                </div>
                <span className="absolute top-2 right-2 p-1.5 rounded-full bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity">
                  <ArrowUpRight className="w-3.5 h-3.5 text-white" />
                </span>
              </a>
            </StaggerItem>
          ))}
        </Stagger>
        <p className="mt-6 text-center text-xs font-mono text-slate-500">Canlı akış yakında · şimdilik Instagram profilimizden takip edebilirsiniz</p>
      </div>
    </section>
  );
}
